// extracted by mini-css-extract-plugin
export default {"SearchInputWrapper":"SearchInput_SearchInputWrapper__OCuux","SearchInputWrapper_Handler":"SearchInput_SearchInputWrapper_Handler__osdl3"};